import moment from 'moment'

/**
 * Formats the text for the footer.
 * Use (date) to insert a date into the text
 * Use (time) to insert the time into the text
 *
 * @param {String} text
 * @param {Date} date
 * @returns The formatted string replacing (date) and (time) with proper variables.
 */
export const buildLastUpdateFooter = (text, date) => {
  if (date !== null && !(date instanceof Date)) {
    date = new Date(date)
  }
  let dateReplace = date == null ? 'mm/dd/yy' : moment(date).format('MM/DD/YY')
  let timeReplace = date == null ? 'hh:mm' : moment(date).format('HH:mm')
  return text.replace('(date)', dateReplace).replace('(time)', timeReplace)
}

/**
 * This method trims the start and end of the string based on the needle given
 *
 * @param {string} needle - The value to trim from the start of the string
 * @param {string} haystack - The value to trim the needle from
 * @returns {string} Removed needle from the start and end of the haystack
 */
export const trim = (needle, haystack) => {
  if (needle === ']') needle = '\\]'
  if (needle === '\\') needle = '\\\\'
  return haystack.replace(
    new RegExp('^[' + needle + ']+|[' + needle + ']+$', 'g'),
    '',
  )
}



// WEBPACK FOOTER //
// ./src/helpers/textbuilders.js